export default __webpack_public_path__ + "static/media/trickortreat_aww_single.f288df04.mp3";